export default __webpack_public_path__ + "static/media/XUSD_01 (1) 1.27af8abf.svg";